/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events at document scope.
 * - openCart: open Melusio's bag drawer (fall back to /cart when it is absent).
 *
 * Both used to point at `theme-drawer#cart-drawer`, Horizon's own drawer. That drawer is
 * no longer rendered — layout/theme.liquid carries the reasoning — and the bag on every
 * template is `melusio-overlay#melusio-cart`. An external caller reaching for
 * Shopify.actions.openCart is asking for the cart the customer can see, so it gets that
 * one instead of a hard navigation to /cart.
 *
 * MelusioOverlay is published by melusio-overlay.js, which is deferred, so it can be
 * undefined when an app calls this early in the page's life. The /cart fallback covers
 * that, and it is the same fallback the old code used when the element was missing.
 */

const CART_OVERLAY_ID = 'melusio-cart';

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    // melusio-cart.js listens on document, so document is where these belong. The old
    // `?? document` fallback resolved here on every page anyway once the element it
    // looked for stopped rendering.
    eventTarget: () => document,
  });

  actions.openCart.configure({
    async handler() {
      const overlay = document.getElementById(CART_OVERLAY_ID);

      if (overlay && window.MelusioOverlay?.open) {
        window.MelusioOverlay.open(CART_OVERLAY_ID);
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
